import {EVENT_SET_JWT} from "../constants";

const setJwt = (jwt, decoded) => ({
  type : EVENT_SET_JWT,
  payload : Object.assign({}, decoded, { token : jwt }),
});

export default setJwt;
